import { NEXT_PUBLIC_IMAGE_URL } from "@/common";

export const jobdetailintro = [
  {
    versionA: {
      title: 'Thấy job xịn rồi thì chuẩn bị gì tiếp?',
      titleColor: 'Upzi có combo hỗ trợ nè:',
      description:
        'Take the guesswork out of managing your money. Our AI-powered budgeting tool adapts to your lifestyle and helps you stay on track.',
      bullets: [
        {
          title: 'Tạo profile ứng tuyển nhanh như chớp',
          description: 'Với AI Parser, bạn dễ dàng tạo & update profile',
          image: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/job_detail_1.png`,
        },
        {
          title: 'AI feedback để cải thiện profile',
          description: 'Phân tích độ phù hợp với các công việc đang tuyển.',
          image: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/job_detail_2.png`,
        },
      ],
    },
    versionB: {
      title: 'Công cụ hỗ trợ ứng tuyển hiệu quả',
      description:
        'Take the guesswork out of managing your money. Our AI-powered budgeting tool adapts to your lifestyle and helps you stay on track.',
      bullets: [
        {
          title: 'Tạo profile ứng tuyển nhanh như chớp',
          description: 'Với AI Parser, bạn dễ dàng tạo & update profile',
          image: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/job_detail_1.png`,
        },
        {
          title: 'AI feedback để cải thiện profile',
          description: 'Phân tích độ phù hợp với các công việc đang tuyển.',
          image: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/job_detail_2.png`,
        },
      ],
    },
  },
];
